import { PRODUCT_CODE_TYPES } from 'constants/product';

import { ISubscription } from 'types/subscription';

export const isMainSubscription = (productCodeType: ISubscription['product_type']) =>
    [PRODUCT_CODE_TYPES.MAIN_SUBSCRIPTION, PRODUCT_CODE_TYPES.UPGRADE_SUBSCRIPTION].includes(productCodeType);
